import React, {Component, useEffect} from 'react';
import {Howl} from 'howler'; // for playing chat audio stream
import { SocketContext } from '../context/socket';
import { ToggleButtonGroup, ToggleButton, Form } from "react-bootstrap";

const annyang = require('annyang/dist/annyang.min.js'); // wrapper around browser voice-to-text engine
const SpeechKITT = require('speechkitt/dist/speechkitt.min.js').SpeechKITT; // GUI for starting/stopping speech recognition
let _offOn = false;

export default class VoiceControl extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            skittMoved:false,
            offOn: false
        }

        this.socket = undefined!;
    }

    private socket: SocketIOClient.Socket;

    static contextType = SocketContext;
    context!: React.ContextType<typeof SocketContext>;

    componentDidMount() {
        this.socket = this.context!;
        
        this.socket.on('speaker', function(audioStream: any) {
            if (_offOn){
                var uInt8Array = new Uint8Array(audioStream);
                var arrayBuffer = uInt8Array.buffer;
                var blob = new Blob([arrayBuffer]);
                var url = URL.createObjectURL(blob);

                annyang.pause();

                var sound = new Howl({
                    src: [url],
                    format: ['mp3'],
                    onend: function() {
                        annyang.resume();
                    }
                });

                sound.play();
            }else{
                console.log("Voice is turned off");
            }
        });
        

        if (annyang) {
            // Add our commands to annyang
            annyang.addCommands({
                // one of the specific map commands handled explicitly
                // in mapInit.ts:
                'map *request': (request: any) => {
                    this.socket.emit('mapVoiceCommand', {command: request});
                },
                // in this case the text is sent through the Lex bot
                // and will show up in the chat component
                'computer *request': (request: any) => {
                    console.log('computer *request: ', request);
                    this.socket.emit('chat', request);
                }
            });

            annyang.addCallback('resultNoMatch', function(phrases: any) {
                console.log('no match: ', phrases[0]);
            });

            SpeechKITT.annyang({ autoRestart: false, continuous: false });

            // Define a stylesheet for KITT to use
            SpeechKITT.setStylesheet('//cdnjs.cloudflare.com/ajax/libs/SpeechKITT/1.0.0/themes/flat.css');

            // Render KITT's interface
            SpeechKITT.vroom();
        }
    
    }

    render() {
        let skitt = document.getElementById("skitt-ui");
        let skittContainer = document.getElementById("input-container");
        if (skitt && skittContainer && !this.state.skittMoved){
            this.setState({
                skittMoved: true
            });
            skittContainer.appendChild(skitt);
        }
        return (
        <div style={{width:"100%"}}>
            <div style={{float:"right"}}>
                <ToggleButton
                    type="checkbox"
                    variant="secondary"
                    checked={this.state.offOn}
                    value="1"
                    onChange={(e:any) => { 
                        this.setState({
                            offOn: e.currentTarget.checked
                        });
                        _offOn = e.currentTarget.checked;
                    }}
                > Voice on?</ToggleButton>
            </div>
        </div>
        );
    }
}
